/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetDoorReportsSummaryQueryResponse,
  GetDoorReportsSummaryQueryParams,
} from '../types/GetDoorReportsSummary'

function getGetDoorReportsSummaryUrl() {
  const res = { method: 'GET', url: `/api/v1/reports/doors/summary/` as const }
  return res
}

/**
 * @description Aggregate summary (places_count, chains_count, total_ltv) for the door reports matching the same filters as listDoorReports. Unlike getChainReportsSummary, this view never overrides get() (only transform_results()), so it inherits the base raw-SQL list get() and the response is an unwrapped `{results: [...]}` envelope containing the single aggregate row -- not a flat object.
 * @summary Door reports aggregate summary
 * {@link /api/v1/reports/doors/summary/}
 */
export async function getDoorReportsSummary(
  params?: GetDoorReportsSummaryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetDoorReportsSummaryQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetDoorReportsSummaryUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
